import React from "react";
import reactLogo from "../img/LOGO-Icontec-2019_ver_white.png";

export const ReactLogo = () => {
  return <img src={reactLogo} alt="React Logo" className="react-logo" />;
};
